export const langs = ["vn",'en']